

export type BooleanValues = 'true' | 'false';

export enum BOOLEAN_VALUES {
    TRUE = 'true',
    FALSE = 'false',
}